import { render } from "./home-about.vue?vue&type=template&id=5b4acc20&scoped=true"
import script from "./home-about.vue?vue&type=script&lang=js"
export * from "./home-about.vue?vue&type=script&lang=js"

import "./home-about.vue?vue&type=style&index=0&id=5b4acc20&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4acc20"]])

export default __exports__